import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "MerchantMarketing" */ './MerchantMarketing'),
    {
        fallback: null,
    }
);
